module.exports = __webpack_public_path__ + "img/pic_germany_06.caf50433.jpg";